import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../setupStore';
import { CaseMassDelegation } from '../../../interfaces/MassDelegation';

export interface MassDelegationDraftState {
  value: CaseMassDelegation | null;
}

const initialState: MassDelegationDraftState = {
  value: null,
};

export const MassDelegationDraftSlice = createSlice({
  name: 'massDelegationDraft',
  initialState,
  reducers: {
    setMassDelegationDraft: (
      state,
      action: PayloadAction<CaseMassDelegation | null>,
    ) => {
      state.value = action.payload;
    },
    clearMassDelegationDraft: (state) => {
      state.value = null;
    },
  },
});

export const { setMassDelegationDraft, clearMassDelegationDraft } =
  MassDelegationDraftSlice.actions;

export const selectDraft = (state: RootState) =>
  state.massDelegationDraft.value;

export default MassDelegationDraftSlice.reducer;
